import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {ScannerTrialPopup} from "./ScannerTrialPopupModal.component";
import {Workspace} from "../../../../model/workspace.data";



export function showScannerTrialPopupModal(modalService: NgbModal, workspace: Workspace, mobileMode: string = 'desktop') {


    if(!workspace.IsScannerTrialExpired) {

        const mobile = mobileMode != 'desktop';
        const component =  mobile? ScannerTrialPopup: ScannerTrialPopup;

        const windowClass = "dark-modal largeWindow" + (mobile ? ' mobile' : '');
        
        let m: NgbModalRef = modalService.open(component, {
            backdrop: "static",
            size: "lg",
            centered: true,
            windowClass: windowClass
        });
        let modal = (<ScannerTrialPopup> m.componentInstance);
        return modal;

    } else {
        return null;
    }
}
